import { render, staticRenderFns } from "./checkboxFiled.vue?vue&type=template&id=354ae415"
import script from "./checkboxFiled.vue?vue&type=script&lang=js"
export * from "./checkboxFiled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports